import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import { GetProductsByProductIdRes } from "api/api/productsApi/types";

export const getProductByProductId = createAsyncThunk<
  GetProductsByProductIdRes,
  number
>("products/getProductByProductId", async (productId, { rejectWithValue }) => {
  try {
    const data = await productsApi.getProductByProductId(productId);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting product by product id", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting product by product id", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
